import Favorite from '@/js/plugins/CookieDb/Favorite';
import { authCheck } from '@/js/helpers';

const main = async () => {
    const FAV_SELECTOR = '.c-buttons-favorite';
    if (document.querySelector(FAV_SELECTOR) === null) return;
    const favorite = new Favorite();
    const target = authCheck() ? 'db' : 'cookie';

    // data-active と aria-pressed を常に同期させる
    const setActive = (el, active) => {
        if (active) {
            el.dataset.active = '';
        } else {
            delete el.dataset.active;
        }
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
    };

    const syncById = (id, active) => {
        document.querySelectorAll(`${FAV_SELECTOR}[data-id="${id}"]`).forEach((el) => {
            setActive(el, active);
        });
        // 詳細ページ等の data-type="favorite" ボタンも同期
        document.querySelectorAll(`[data-type="favorite"][data-id="${id}"]`).forEach((el) => {
            setActive(el, active);
        });
    };

    const syncFavoriteCount = (count) => {
        document.querySelectorAll('[data-favorite-count]').forEach((targetObj) => {
            targetObj.textContent = count < 99 ? String(count) : '99+';
            targetObj.dataset.count = String(count);
            targetObj.hidden = count <= 0;
        });
    };

    document.querySelectorAll(FAV_SELECTOR).forEach((obj) => {
        if (obj.dataset.favBound) return;
        obj.dataset.favBound = "1";
        const id = obj.dataset.id;

        obj.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!id) return;

            const prevState = obj.hasAttribute('data-active');
            const nextState = !prevState;
            syncById(id, nextState);
            const resp = await favorite.setState(target, id, nextState);
            if (!resp) {
                syncById(id, prevState);
                return;
            }
            favorite.getAll(target).then((favorites) => {
                syncFavoriteCount(favorites.length);
            });
        });
    });

    // お気に入りボタン初期表示
    favorite.getAll(target).then((favorites) => {
        favorites.forEach((favoriteId) => {
            syncById(String(favoriteId), true);
        });
        syncFavoriteCount(favorites.length);
    });
}

export default main;
